import { computed, defineComponent, nextTick, ref } from "vue";
import InputText from "../forms/InputText";
import InputCheckbox from "../forms/InputCheckbox";
import Validator, { ValidationError } from "../utils/Validator";
import Utils from "../utils/Utils";

export default defineComponent({
    components: {
        InputText,
        InputCheckbox,
    },

    template: `
        <div class="SmePhoneForm">
            <template v-if="!submited">
                <slot></slot>

                <InputText label="Numer telefonu" v-model="form.phone" :required="true" :error="errors.phone" />

                <div class="SmePhoneForm__terms">
                    <InputCheckbox title="Wyrażam zgodę na otrzymywanie od Respect Energy S.A informacji handlowych dotyczących produktów i usług Respect Energy S.A za pośrednictwem telefonu." v-model="form.terms" :error="errors.terms" />
                </div>

                <div class="SmePhoneForm__submit">
                    <slot name="submit"></slot>
                    <button type="button" class="button button--primary button--full" @click="onSubmit">{{ button_label }}</button>
                </div>
            </template>

            <template v-if="submited">
                <p>Dziękujemy za przesłanie formularza. Nasz doradca skontaktuje się z Tobą.</p>
            </template>
        </div>
    `,

    props: {
        type: { type: String },

        button_label: { type: String, default: 'Dalej' },
    },

    setup(props, ctx) {
        const sent = ref(false);
        const submited = ref(false);

        const form = ref({
            phone: null as string,

            terms: null as boolean,
        });

        const errors = ref({
            phone: computed(() => inputError('phone', sent.value)),
            terms: computed(() => inputError('terms', sent.value)),
        });

        function assertError(field: string, force: boolean = false) {
            field == 'phone' && (force || form.value.phone) && Validator.assertPhone(form.value.phone);

            if (field == 'terms' && force && !form.value.terms) {
                throw new ValidationError('To pole jest wymagane');
            }
        }

        function inputError(field: string, force: boolean = false) {
            try {
                assertError(field, force);
            } catch (e) {
                if (e instanceof ValidationError) {
                    return e.message;
                }

                return 'Błędny format pola';
            }
        }

        function assertValid() {
            assertError('phone', true);
            assertError('terms', true);
        }

        async function onSubmit() {
            sent.value = true;

            try {
                assertValid();

                const r = await Utils.setCart('sme/contact', {
                    type: props.type,
                    form: form.value,
                }, false);

                submited.value = true;
            } catch (e) {
                submited.value = false;

                nextTick(() => {
                    const $first = $('.InputWidget--error, .InputCheckbox--error').first();
                    Utils.scrollToEl($first);
                });
            }
        }

        return {
            sent,
            submited,
            form,
            errors,

            onSubmit,
        };
    },
});
